import '@ali/aps-dev/dist/css/aps.css';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import CheckListMobile from '../Screen/CheckListMobile';
import SearchBox from './SearchBox';
import './bannerTop.scss';

@inject('bannerTopStore', 'resultListStore', 'checkListStore')
@observer
class BannerTop extends Component {
  constructor(props) {
    super(props);
    this.bannerTopStore = this.props.bannerTopStore;
    this.resultListStore = this.props.resultListStore;
    this.checkListStore = this.props.checkListStore;
    this.handlerInputChange = this.bannerTopStore.handlerInputChange.bind(this.bannerTopStore, event);
    this.handlerCleanCheck = this.checkListStore.handlerCleanCheck.bind(this.checkListStore);
    this.handlerChangeCheckSuffix = this.checkListStore.handlerChangeCheckSuffix.bind(this.checkListStore);
    this.handlerChangePageSize = this.resultListStore.handlerChangePageSize.bind(this.resultListStore);
    this.fetchresultList = this.resultListStore.fetchresultList.bind(this.resultListStore);
  }
  handlerEnterFind(event) {
    if (event.keyCode == 13) {
      this.handlerSearchResult();
    }
  }
  handlerSearchResult() {
    this.handlerCleanCheck();
    this.handlerChangeCheckSuffix(this.bannerTopStore.suffix);
    this.handlerChangePageSize(10);
    this.fetchresultList({
      'keyWord': this.bannerTopStore.keyword,
      'pageSize': this.resultListStore.pageSize,
      'suffix': this.bannerTopStore.suffix
    });
  }
  render() {
    const headerBgImgUrl = window.headerBgImg || 'https://img.alicdn.com/tfs/TB10haJaOqAXuNjy1XdXXaYcVXa-713-64.png';
    return (
      <div className="banner-container">
        <div className="banner-title">
          <img src={headerBgImgUrl} alt="用白金域名，塑成功形象" />
        </div>
        <div className="banner-description">
          <ul>
            <li>• {window.headContent1 || '简单明了，过目不忘，物超所值'}</li>
            <li>• {window.headContent2 || '入口制胜，彰显品牌形象和实力'}</li>
          </ul>
          <ul>
            <li>• {window.headContent3 || '好域名有时比CEO更重要，助力事业，成就梦想'}</li>
            <li>• {window.headContent4 || '跳跃在地址栏的财富，互联网时代更具价值的数字资产'}</li>
          </ul>
        </div>
        <SearchBox
          value={this.bannerTopStore.inputDomain || ''}
          handlerInputChange={this.handlerInputChange}
          handlerEnterFind={this.handlerEnterFind.bind(this)}
          handlerSearchResult={this.handlerSearchResult.bind(this)} />
        {
          this.checkListStore.isShowCheckList ? <CheckListMobile /> : null
        }
      </div>
    );
  }
}
export default BannerTop;


// WEBPACK FOOTER //
// ./src/components/BannerTop/BannerTop.js